import React from 'react';
import Container from '../../components/Container';
import {Main} from '../../layouts';
import {Typography} from '@mui/material';

const PrivacyView = () => {

    return (<Main>
            <Container>
                <Typography variant="h4">Security And Privacy Policy</Typography>
                <br/>
                <Typography variant="body2">
                    Vampire Labs, LLC (Vampire Labs) is committed to protecting the privacy of everyone who visits our
                    web site, responds to our interactive advertisements, or sends us e-mail. This Privacy Policy
                    Statement outlines how we collect and use information. It also tells you what to do if you do not
                    want your personal information collected when visiting our Web site, responding to web-based
                    advertisements or sending us e-mail.
                </Typography>
                <br/>
                <Typography variant="h5">How We Collect Information</Typography>
                <Typography variant="body2">
                    We do not collect any personal information (name, address, telephone number or e-mail address)
                    unless you provide it. We may request this information when a product or demo is downloaded, for
                    newsletter subscriptions, or when additional information about our products or services is
                    requested.
                    <br/>
                    <br/>
                    If you have submitted personal information and want it removed from our records, please contact us
                    at the e-mail address listed at the bottom of this Privacy Statement.
                </Typography>
                <br/>
                <Typography variant="h5">How We Use Information</Typography>
                <Typography variant="body2">
                    We store and use information provided by you to better understand customer needs, as well as
                    determine how we can improve our products and services. With your permission, we may also use this
                    information to contact you with announcements and promotions, or if there is a question about your
                    account.
                    <br/>
                    <br/>
                    We do not share, rent or sell your information with third parties, except to provide products or
                    services you request.
                </Typography>
                <br/>
                <Typography variant="h5">Protecting Personal Information</Typography>
                <Typography variant="body2">
                    Through appropriate physical, electronic and managerial procedures we strive to prevent unauthorized
                    parties from viewing that information. However, no data transmission over the Internet is 100%
                    secure. As a result, we cannot guarantee the security of the information that you transmit via our
                    online services.
                    <br/>
                    <br/>
                    Please note that any information that you post to a public discussion group is available to all
                    persons accessing that location. In addition, you should be aware that some discussion groups offer
                    a service in which subscribers are e-mailed a copy of all messages posted to the group on a
                    particular topic. Consequently, if you post a message to the group, your e-mail address may be sent
                    to those subscribers that have indicated an interest in the topic of your message.
                </Typography>
                <br/>
                <Typography variant="h5">Children’s Privacy</Typography>
                <Typography variant="body2">
                    Protecting the privacy of persons under the age of 13 is especially important. For that reason, we
                    never collect or maintain information from our site from persons we actually know are under 13, and
                    no part of our site structured to attract anyone under 13. If a person under 13 has provided
                    personal information to us, we ask that a parent or guardian of the person contact us at the email
                    address below if they would like that information removed from our database and we will use all
                    reasonable efforts to do so.
                </Typography>
                <br/>
                <Typography variant="h5">Non-Identifiable Information</Typography>
                <Typography variant="body2">
                    In some instances we collect information that is not personally identifiable. Examples of this type
                    of information include the type of computer operating system used, the type of Web browser used, or
                    the domain name of the Web site which linked to our site. This information helps us analyze trends,
                    administer our site, and gather information for marketing and other use.
                </Typography>
                <br/>
                <Typography variant="h5">Web Cookies</Typography>
                <Typography variant="body2">
                    When you view our Web site, we may store a small amount of data on your computer. This data is in
                    the form of a “Cookie.” It can only be read by the server that sent it. Cookies act as a way to
                    record passwords, orders and preferences for visiting our site. In addition, cookies allow us to
                    remember you across pages of our Web site or multiple visits.
                    <br/>
                    <br/>
                    Most Web browsers allow you to erase cookies, block cookies or receive a warning before a cookie is
                    stored. Refer to your Browser instructions or help screen to learn more about these functions.
                    Cookies cannot be executed as code or deliver viruses.
                </Typography>
                <br/>
                <Typography variant="h5">Declining E-mail Offers</Typography>
                <Typography variant="body2">
                    You may unsubscribe from a particular e-mail list at any time by selecting the unsubscribe option
                    within the body of the e-mail. All e-mail offers that you receive from Vampire Labs inform you of
                    how to decline receiving further offers.
                </Typography>
                <br/>
                <Typography variant="h5">Privacy Warning</Typography>
                <Typography variant="body2">
                    Remember, no data transmission over the Internet is 100% secure. Vampire Labs makes no guarantee as
                    to the security of the information that you transmit via our online services.
                    <br/>
                    <br/>
                    Please note that Vampire Labs reserves the right to access and disclose the user information
                    referenced in this Policy (including personal information) as required by courts and administrative
                    agencies, and to the extent required to permit us to investigate suspected fraud, harassment or
                    other violations of our site terms of use or other policies.
                </Typography>
                <br/>
                <Typography variant="h5">Consent</Typography>
                <Typography variant="body2">
                    By using our sites, you consent to the collection, use, and storage of your personal and
                    non-personal information as described in this policy. We may amend this policy from time to time,
                    and if we do we will post those changes on this page so that you are always aware of what
                    information we collect and how we intend to use it.
                </Typography>
                <br/>
                <Typography variant="h5">Contact Us</Typography>
                <Typography variant="body2">
                    We take safeguarding your privacy very seriously. If you have any questions or concerns, or would
                    like to be removed from a mailing list, please contact Subscription Services Manager at <a
                    href="mailto:info@vampirelabs.com">info@vampirelabs.com</a>
                    <br/>
                    <br/>
                    Note: Vampire Labs is not responsible for the content or privacy practices of non-Vampire Labs Web
                    sites to which this site may link. You should review the privacy policy of those sites before you
                    use them.
                </Typography>
            </Container>
        </Main>);
};

export default PrivacyView;